import React, { useEffect } from "react";
import { Button, Col } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";
import { whiteLabelJRStep } from "../../../../qraphql/globalVar/state";
import Logo from "./img/setup-complete.png";

export default function ThirdStep() {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  useEffect(() => {
    const currentStep = document.querySelector("#domainStep3");
    if (currentStep) {
      currentStep.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  }, []);

  return (
    <>
      <div className="mx-auto text-center border rounded-2 mb-3">
        <Col xs={12} md={7} className="mx-auto p-5">
          <img
            src={Logo}
            loading="lazy"
            alt="Setup Complete"
            className="img-fluid pb-2 mb-4"
          />
          <div className="fs-5 fw-bold mb-3 px-lg-4">
            {t(
              "whiteLabel.Setup Complete! We are Verifying your Connection Now."
            )}
          </div>
          <div className="fs-7 text-info mb-4">
            {t(
              "whiteLabel.All changes can take up to 72 hours. Check domain status in Custom Domain page settings."
            )}
          </div>
          <Col md={8} className="mx-auto px-1">
            <Link to={`${lng}/custom-domain`}>
              <Button
                variant="success"
                className="w-100 text-white fw-bold py-2 mb-4"
                onClick={() => whiteLabelJRStep(10)}
              >
                {t("whiteLabel.Check Status")}
              </Button>
            </Link>
          </Col>
        </Col>
      </div>
      <div className="d-flex text-info align-items-center mb-5 fs-7">
        <QuestionCircle className="me-2" />
        {t("whiteLabel.Need help?")}
        <Link
          className="text-success ms-1"
          to={
            process.env.REACT_APP_TICKET_URL + lng + "/organizer-support-chat"
          }
        >
          {t("whiteLabel.Contact Us")}
        </Link>
      </div>
    </>
  );
}
